import MaskedInput from "react-text-mask";
import {
  DESCRIPTION_INPUT_CLASS,
  FieldLabel,
} from "./descriptionUi";
import {
  buildPropertyAlternativePhoneMask,
} from "../../utils/propertyAlternativeContact";

type Props = {
  contactEmail: string;
  contactPhone: string;
  contactEmailError?: string;
  contactPhoneError?: string;
  onContactEmailChange: (value: string) => void;
  onContactPhoneChange: (value: string) => void;
};

export function PropertyAlternativeContactFields({
  contactEmail,
  contactPhone,
  contactEmailError,
  contactPhoneError,
  onContactEmailChange,
  onContactPhoneChange,
}: Props) {
  return (
    <div className="mt-4 rounded-lg border border-slate-200 bg-slate-50/70 p-4">
      <div className="mb-3">
        <p className="text-sm font-semibold text-slate-800">
          Contato alternativo do imóvel
        </p>
        <p className="mt-1 text-xs text-slate-500">
          Opcional. Use quando as comunicações deste imóvel devem ir para outra
          pessoa (administrador, cônjuge, assistente). Não altera o login do
          proprietário.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <label className="flex min-w-0 flex-col gap-1 text-left">
          <FieldLabel error={contactEmailError}>E-mail de contato</FieldLabel>
          <input
            type="email"
            className={DESCRIPTION_INPUT_CLASS}
            value={contactEmail}
            onChange={(event) => onContactEmailChange(event.target.value)}
            placeholder="administrador@condominio.com"
            autoComplete="off"
          />
        </label>

        <label className="flex min-w-0 flex-col gap-1 text-left">
          <FieldLabel error={contactPhoneError}>Telefone de contato</FieldLabel>
          <MaskedInput
            mask={buildPropertyAlternativePhoneMask(contactPhone)}
            guide={false}
            type="tel"
            className={DESCRIPTION_INPUT_CLASS}
            value={contactPhone}
            onChange={(event) => onContactPhoneChange(event.target.value)}
            placeholder="(__) _____-____"
          />
        </label>
      </div>
    </div>
  );
}
